export const LINK_PRIVACY_POLICY = 'https://www.boots.com/floating-editorial/editorial-legal/privacypolicy'
export const LOYALTY_CARD_LINK = 'https://www.boots.com/functional-pages/advantage-card'
